class Addons extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      input: '[addon-input]',
      productInfo: 'product-info',
      addToCartBtn: 'product-form .product-form__submit-cs',
      regularPrice: '.prod-price__block .price:not(.price--on-sale) .price__regular .price-item.price-item--regular',
      salePrice: '.prod-price__block .price.price--on-sale .price-item.price-item--sale'
    };
    this.totalPrice = 0;
    this.init();
    this.addEventListener('updateAddons', () => { this.updateButtonText(); });
  }

  init() {
    this.inputs = this.querySelectorAll(this.selectors.input);
    this.parentEle = this.closest(this.selectors.productInfo);
    this.addToCartBtn = this.parentEle?.querySelector(this.selectors.addToCartBtn);
    this.initEvt();
  }

  initEvt() {
    this.inputs?.forEach(input => {
      input?.addEventListener('change', () => {
        const price = Number(input.dataset.price) || 0;

        if (input.checked) {
          this.addPrice(price);
        } else {
          this.subtractPrice(price);
        }
        this.updateButtonText();
        this.updatePrice();
      });
    });
  }

  addPrice(price) {
    this.totalPrice += price;
  }

  subtractPrice(price) {
    this.totalPrice -= price;
  }

  updateButtonText() {
    const itemCount = Array.from(this.inputs).filter(input => input.checked).length;
    const textEle = this.addToCartBtn?.querySelector('*>span');
    if (itemCount > 0) {
      textEle.textContent = this.addToCartBtn.dataset.text + ' — ' + `${itemCount} item(s)`;
    } else {
      textEle.textContent = this.addToCartBtn.dataset.text;
    }
  }

  updatePrice() {
    // let currentPrice = 0;
    // console.log(this.totalPrice);

    // const regularPriceElement = this.parentEle?.querySelector(this.selectors.regularPrice);

    // const salePriceElement = this.parentEle?.querySelector(this.selectors.salePrice);
  }
}

customElements.define('addons-items', Addons);
